import { z } from "zod";
import { CefrLevelSchema, TopicSchema } from "./vocab.js";
export const DashboardStatsSchema = z.object({
    entries_total: z.number().int().nonnegative(),
    flashcards_total: z.number().int().nonnegative(),
    due_now: z.number().int().nonnegative(),
    reviews_today: z.number().int().nonnegative(),
    streak_days: z.number().int().nonnegative(),
    /** Fraction 0-1 of non-"again" ratings over the last 30 days; null when no reviews yet */
    retention_30d: z.number().min(0).max(1).nullable(),
    cefr_distribution: z.array(z.object({ level: CefrLevelSchema, count: z.number().int().nonnegative() })),
    topic_distribution: z.array(z.object({ topic: TopicSchema, count: z.number().int().nonnegative() })),
    /** Last 14 days, oldest first; date is YYYY-MM-DD in server-local time */
    reviews_by_day: z.array(z.object({ date: z.string(), count: z.number().int().nonnegative() })),
});
//# sourceMappingURL=stats.js.map